package com.eladfinish.bible.contest.screens.main.ui

import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.foundation.Image
import androidx.compose.foundation.border
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorPrimaryDark
import com.eladfinish.bible.contest.common.gender.HebrewGender
import com.eladfinish.bible.contest.common.gender.personalizeGender
import com.eladfinish.bible.contest.ic_button_drag
import com.eladfinish.bible.contest.screens.main.data.ButtonIcon
import com.eladfinish.bible.contest.screens.main.data.ItemMode
import com.eladfinish.bible.contest.strokeColor
import com.eladfinish.bible.contest.ui.extensions.conditional
import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.compose.colorResource
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.compose.stringResource

@Composable
fun IconTextButton(
    modifier: Modifier = Modifier,
    stringResource: StringResource,
    icon: ButtonIcon,
    onClick: () -> Unit,
    onLongClick: () -> Unit,
    itemMode: ItemMode = ItemMode.REGULAR,
    isDragging: Boolean = false,
    hebrewGender: HebrewGender,
    fontSize: TextUnit = 18.sp,
    isDebug: Boolean = false,
) {
    val backgroundAlpha = animateFloatAsState(if (isDragging) 0.6f else 1f)
    Button(
        elevation = ButtonDefaults.buttonElevation(
            defaultElevation = 0.dp,
            pressedElevation = 8.dp,
            disabledElevation = 0.dp
        ),
        onClick = onClick,
        modifier = modifier
            .fillMaxWidth()
            .border(
                width = 1.dp,
                color = colorResource(resource = SharedRes.colors.strokeColor),
                shape = RoundedCornerShape(12.dp),
            ),
        shape = RoundedCornerShape(12.dp),
        colors = ButtonDefaults.buttonColors(
            containerColor = colorResource(resource = SharedRes.colors.colorPrimaryDark)
                .copy(alpha = backgroundAlpha.value),
        ),
        contentPadding = PaddingValues(
            when (itemMode) {
                ItemMode.REGULAR -> 4
                ItemMode.DRAGGABLE -> 1
            }.dp
        ),
    ) {
        Box(
            modifier = Modifier,
            contentAlignment = Alignment.TopEnd,
        ) {
            if (itemMode == ItemMode.DRAGGABLE) {
                Image(
                    painter = painterResource(SharedRes.images.ic_button_drag),
                    contentDescription = null,
                    modifier = Modifier.size(48.dp),
                    colorFilter = ColorFilter.tint(Color.White),
                )
            }

            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center,
                modifier = Modifier
                    .heightIn(min = 60.dp)
                    .fillMaxWidth()
                    .conditional(condition = isDebug) {
                        when (itemMode) {
                            ItemMode.REGULAR -> {
                                combinedClickable(
                                    onClick = onClick,
                                    onLongClick = onLongClick,
                                )
                            }

                            ItemMode.DRAGGABLE -> Modifier
                        }
                    },
            ) {
                Image(
                    painter = when (icon) {
                        is ButtonIcon.Resource -> painterResource(icon.imageResource)
                        is ButtonIcon.Vector -> rememberVectorPainter(icon.imageVector)
                    },
                    contentDescription = null,
                    modifier = Modifier.size(48.dp),
                    colorFilter = ColorFilter.tint(Color.White),
                )
                Text(
                    text = stringResource(resource = stringResource).personalizeGender(hebrewGender),
                    fontSize = fontSize,
                    style = MaterialTheme.typography.labelLarge,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.padding(top = 2.dp),
                    color = Color.White,
                )
            }
        }
    }
}
